/// <reference path="appbase.ts" />


namespace TerminalApp {
    class StatusResponse {
        bar: HTMLElement;
        container: HTMLElement;
        user: string;
        time: number;
        width: number;
    }

    export class App_Status extends AppBase {
        master: string;
        bound = false;
        output = document.getElementById("ast_output");
        max_response_time = document.getElementById("ast_max_response_time");
        responses: StatusResponse[] = [];
        sum: number = 0;
        count: number = 0;
        avrage: number = 0;
        max: number = 0;
        constructor() {
            super("app_status");
        }


        async onOpen() {
            if (!this.bound) {
                this.sum = this.count = this.avrage = this.max = 0;
                this.responses = [];
                this.bound = true;
                this.ping();
            }
        }

        async onClose() {
            if (this.bound) {
                this.bound = false;
            }
        }


        async ping() {
            var now = performance.now();
            var response = new StatusResponse();
            response.user = await hub.connection.invoke<string>("pingStatus");
            response.time = performance.now() - now;
            this.count++;
            this.sum += response.time;
            this.avrage = this.sum / this.count;

            if (response.time > this.max) {
                this.max = response.time;
                this.max_response_time.innerHTML = this.max.toFixed(2) + " ms";
            }


            var outer = response.container = document.createElement("div");
            outer.classList.add("outer");

            var bar = response.bar = document.createElement("div");
            bar.classList.add("bar");
            outer.appendChild(bar);

            var text = document.createElement("div");
            text.classList.add("text");
            text.innerHTML = response.time.toFixed(2) + "ms (" + response.user + ")";
            outer.appendChild(text);

            this.output.prepend(outer);
            this.responses.push(response);

            if (this.responses.length > 40) {
                var first = this.responses.shift();
                first.container.remove();
            }

            for (let i = 0; i < this.responses.length; i++) {
                let cr = this.responses[i];
                cr.bar.style.width = (cr.time / this.max * 100).toFixed(1) + "%";
            }

            await SP.sleep(100);

            if (this.bound)
                this.ping();
        }
    }



    RegisterApp("app_status", App_Status);
}